const FIN_SOB_TRANSLATION_NAMESPACE = 'jbp-fin-sob'

export const TRANSLATION_KEYS = {
  selectedNotApplicableCategory: `${FIN_SOB_TRANSLATION_NAMESPACE}-selected-not-applicable-category`,
  switchOn: `${FIN_SOB_TRANSLATION_NAMESPACE}-switch-on`,
}
